import type { ReactElement } from 'react';
import { Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import type { BackofficeModule } from '../registry';
import { RidebookDraftPage, RidebookNewPage, RidebookOrderPage } from './RidebookOrderPage';
import { RidebookPage } from './RidebookPage';

const gate = (permission: string, element: ReactElement) => <ModuleGate module="ridebook" permission={permission}>{element}</ModuleGate>;

/** Einstiegspunkt des Moduls Auftragsbuch Personenbeförderung im Backoffice (Schlüssel `ridebook`, § 49 Abs. 4 PBefG, siehe docs/auftragsbuch.md) unter /auftragsbuch */
export const ridebookModule: BackofficeModule = {
  key: 'ridebook',
  path: '/auftragsbuch',
  nav: [{ label: 'Auftragsbuch', path: '/auftragsbuch' }],
  routes: (
    <>
      <Route path="auftragsbuch" element={gate('ridebook.read', <RidebookPage />)} />
      <Route path="auftragsbuch/neu" element={gate('ridebook.write', <RidebookNewPage />)} />
      <Route path="auftragsbuch/entwurf/:id" element={gate('ridebook.read', <RidebookDraftPage />)} />
      <Route path="auftragsbuch/:id" element={gate('ridebook.read', <RidebookOrderPage />)} />
    </>
  ),
};
